import { MaxmindResponse } from 'embed/constants/maxmind'
import MaxMindGeolocator, { isMaxmindResponse } from 'embed/services/MaxMindGeolocator'

/**
 * A common location object we can use to abstract away the geolocation provider
 */
export interface CommonLocation {
  zipcode: string
  city: string
  state: string
}

interface FionaLocationResponse {
  'Country-Region': string
  'Country-Region-Name': string
  'Metro-Code': string
  'Postal-Code': string
  'Time-Zone': string
  ipAddress: string
}

/**
 * Converts Maxmind repsonses to CommonLocations
 */
export const convertMaxmindGeolocation = (maxmindResponse: MaxmindResponse): CommonLocation | undefined => {
  if (isMaxmindResponse(maxmindResponse)) {
    return {
      city: maxmindResponse.city.names.en,
      state: maxmindResponse.subdivisions[0].iso_code,
      zipcode: maxmindResponse.postal.code,
    }
  }
  return
}

/**
 * Returns a CommonLocation from Maxmind
 */
export const getGeoFromIP = (): Promise<CommonLocation | undefined> =>
  MaxMindGeolocator.getGeoFromIP().then(convertMaxmindGeolocation)

/**
 * Returns a CommonLocation from Maxmind
 */
export const getGeoFromFionaAPI = async (): Promise<Omit<CommonLocation, 'city'> & FionaLocationResponse> => {
  const response = await fetch('https://fiona.com/api/lambdas/location')
  const data: FionaLocationResponse = await response.json()
  return {
    ...data,
    state: data['Country-Region'],
    zipcode: data['Postal-Code'],
  }
}
